export default "__VITE_ASSET__Ba3sBbRN__$_?format=webp__"